<template>
  <div class="l-app">
    <div ref="header" class="l-sensorHeader">
      <PHeader />
    </div>
    <div class="l-sensorMain">
      <router-view />
    </div>
  </div>
</template>

<script>
import PHeader from '@/components/common/PHeader.vue'

export default {
  name: 'SensorLayout',
  components: {
    PHeader,
  },
}
</script>
